export const BOARDS_HEIGHT_STORAGE_KEY = 'sia.boardsSectionHeightPx'
export const BOARDS_HEIGHT_MIN = 200
export const BOARDS_HEIGHT_MAX = 600
export const BOARDS_HEIGHT_DEFAULT = 215

export function readStoredBoardsHeight() {
  try {
    const raw = localStorage.getItem(BOARDS_HEIGHT_STORAGE_KEY)
    if (raw == null) return BOARDS_HEIGHT_DEFAULT
    const n = parseInt(raw, 10)
    if (Number.isNaN(n)) return BOARDS_HEIGHT_DEFAULT
    return Math.min(BOARDS_HEIGHT_MAX, Math.max(BOARDS_HEIGHT_MIN, n))
  } catch {
    return BOARDS_HEIGHT_DEFAULT
  }
}
